import React from "react";
import { useSettings } from "@/context/SettingsContext";

/**
 * Injects CSS variables from settings so the entire site respects admin-editable theme colors.
 * Mounted once inside layouts. Falls back to defaults defined in index.css when a setting is empty.
 */
export default function ThemeInjector() {
  const { settings } = useSettings();
  const css = `
    :root {
      ${settings.theme_primary ? `--marupiara-gold: ${settings.theme_primary};` : ""}
      ${settings.theme_primary_dark ? `--marupiara-gold-dark: ${settings.theme_primary_dark};` : ""}
      ${settings.theme_primary_light ? `--marupiara-gold-light: ${settings.theme_primary_light};` : ""}
      ${settings.theme_dark_bg ? `--marupiara-obsidian: ${settings.theme_dark_bg};` : ""}
      ${settings.theme_dark_bg_soft ? `--marupiara-charcoal: ${settings.theme_dark_bg_soft};` : ""}
      ${settings.theme_light_bg ? `--marupiara-ivory: ${settings.theme_light_bg};` : ""}
      ${settings.theme_light_bg_soft ? `--marupiara-cream: ${settings.theme_light_bg_soft};` : ""}
      ${settings.theme_text_on_dark ? `--marupiara-text-on-dark: ${settings.theme_text_on_dark};` : "--marupiara-text-on-dark: #FDFBF7;"}
      ${settings.theme_text_on_dark_muted ? `--marupiara-text-on-dark-muted: ${settings.theme_text_on_dark_muted};` : "--marupiara-text-on-dark-muted: #C7C1B4;"}
      ${settings.theme_text_on_light ? `--marupiara-text-on-light: ${settings.theme_text_on_light};` : "--marupiara-text-on-light: #171717;"}
      ${settings.theme_text_on_light_muted ? `--marupiara-text-on-light-muted: ${settings.theme_text_on_light_muted};` : "--marupiara-text-on-light-muted: #525252;"}
    }
  `;
  return <style>{css}</style>;
}
